import type { ApiResponse } from "@/types/common";
import type {
  CustomerKycDto,
  CustomerMemberProfileDto,
  UserCouponDto,
  WalletTransferDto,
} from "@/types/customer.dto";
import { apiClient, unwrapApiResponse } from "./httpClient";

export const customerService = {
  getMemberProfile(): Promise<CustomerMemberProfileDto> {
    return unwrapApiResponse(apiClient.get<ApiResponse<CustomerMemberProfileDto>>("/Users/me/member"));
  },

  submitKyc(dto: CustomerKycDto): Promise<CustomerMemberProfileDto> {
    return unwrapApiResponse(apiClient.put<ApiResponse<CustomerMemberProfileDto>>("/Users/me/kyc", dto));
  },

  activateMember(): Promise<CustomerMemberProfileDto> {
    return unwrapApiResponse(apiClient.post<ApiResponse<CustomerMemberProfileDto>>("/Users/me/member/activate"));
  },

  getCoupons(): Promise<UserCouponDto[]> {
    return unwrapApiResponse(apiClient.get<ApiResponse<UserCouponDto[]>>("/Users/me/coupons"));
  },
};

export const walletTransferService = {
  transfer(dto: WalletTransferDto): Promise<boolean> {
    return unwrapApiResponse(apiClient.post<ApiResponse<boolean>>("/Wallets/transfer", dto));
  },
};
